import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-grid-row',
  styleUrls: ['./grid-row.component.scss'],
  templateUrl: './grid-row.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridRowComponent {
  @HostBinding('class')
  readonly cssClasses = 'grid-row';
}
